/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetailsStats_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsHeader_user">;
    readonly " $refType": "PdpRespDealerDetailsStats_user";
};
export type PdpRespDealerDetailsStats_user$data = PdpRespDealerDetailsStats_user;
export type PdpRespDealerDetailsStats_user$key = {
    readonly " $data"?: PdpRespDealerDetailsStats_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetailsStats_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetailsStats_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user",
      "args": null
    }
  ]
};
(node as any).hash = '76a3ccc76e649cf40a4e2b84d0604094';
export default node;
